import { createSelector } from 'reselect';
import { getAllSureMotorClaim } from './index';

export const getBasicDetailsDetails = createSelector(
    getAllSureMotorClaim,
    (allSureMotorClaim) => allSureMotorClaim.basicDetails
);

export const getBasicDetailsForm = createSelector(
    getBasicDetailsDetails,
    (basicDetails) => basicDetails.form
);
export const getSelectedCategoryType = createSelector(
    getBasicDetailsForm,
    (basicDetailsForm) => basicDetailsForm.categoryType.value
);



